import { IAPIDatasourceSummaryStats } from "../interfaces/api-datasources-summary-stats.interface";

export class DatasourceSummaryStatsModel {
    public dataSourceCode: string;
    public recordCount: number;
    public mergedRecordCount: number;
    public mergedRecordPercent: number;
    public disclosedRecordCount: number;
    public possibleMatchCount: number;
    public ambiguousCount: number;
    public possibleRelationshipCount: number;
    public discoveredPercent: number;
    
    constructor(data?: Partial<DatasourceSummaryStatsModel>) {
        this.dataSourceCode = data && data.dataSourceCode || '';
        this.recordCount = data && data.recordCount || 0;
        this.mergedRecordCount = data && data.mergedRecordCount || 0;
        this.mergedRecordPercent = data && data.mergedRecordPercent || 0;
        this.disclosedRecordCount = data && data.disclosedRecordCount || 0;
        this.possibleMatchCount = data && data.possibleMatchCount || 0;
        this.ambiguousCount = data && data.ambiguousCount || 0;
        this.possibleRelationshipCount = data && data.possibleRelationshipCount || 0;
        this.discoveredPercent = data && data.discoveredPercent || 0;
    }


    static Deserialize(api: IAPIDatasourceSummaryStats): DatasourceSummaryStatsModel {
        const data: DatasourceSummaryStatsModel = {
            dataSourceCode: api.dataSourceCode,
            recordCount: api.recordCount,
            mergedRecordCount: api.mergedRecordCount,
            mergedRecordPercent: api.mergedRecordPercent,
            disclosedRecordCount: api.disclosedRecordCount,
            possibleMatchCount: api.possibleMatchCount,
            ambiguousCount: api.ambiguousCount,
            possibleRelationshipCount: api.possibleRelationshipCount,
            discoveredPercent: api.discoveredPercent,
        };

        return new DatasourceSummaryStatsModel(data);
    }

    static DeserializeList(api: IAPIDatasourceSummaryStats[]): DatasourceSummaryStatsModel[] {
        if (!Array.isArray(api)) {
            return [];
        }

        return api.map(a => DatasourceSummaryStatsModel.Deserialize(a));
    }
}